"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../constants");
var services_1 = require("../../services");
function getIdsFromCompetitorId(competitorId) {
    var splittedId = competitorId.split(constants_1.idPathDivider);
    if (splittedId.length === 1) {
        var error_1 = {
            name: "getIdsFromCompetitorId: failed to split competitorId",
            message: "competitorId: " + competitorId,
        };
        services_1.sentryHub.withScope(function (scope) {
            scope.setExtras({
                competitorId: competitorId,
            });
            scope.setTag('util failed', 'getIdsFromCompetitorId');
            services_1.sentryHub.captureException(error_1);
        });
        return { matchId: '', competitorId: '' };
    }
    return {
        matchId: splittedId[0],
        competitorId: splittedId[1],
    };
}
exports.default = getIdsFromCompetitorId;
//# sourceMappingURL=getIdsFromCompetitorId.js.map